/* Disable since this is just data */
/* eslint-disable max-lines-per-function */
import type { ItemCardFeatures } from './types';
import type { BabbelTheme } from '@lessonnine/design-tokens.lib/dist/json/theme';

export default (theme: BabbelTheme): ItemCardFeatures => ({
  courses_beginner: {
    width: '74.53px',
    height: '85.94px',
    backgroundColor: theme.color.illustration.violet.light,
    cardPositionBottom: '40px',
    cardPositionRight: '-115px',
    imagePositionBottom: '4px',
    imagePositionRight: '0'
  },
  origins_beginner: {
    width: '87.73px',
    height: '56.04px',
    backgroundColor: theme.color.illustration.emerald.default,
    cardPositionBottom: '0',
    cardPositionRight: '0',
    imagePositionBottom: '0',
    imagePositionRight: '5px'
  },
  babbel_live_beginner: {
    width: '87.73px',
    height: '56.04px',
    backgroundColor: theme.color.illustration.emerald.default,
    cardPositionBottom: '0',
    cardPositionRight: '0',
    imagePositionBottom: '0',
    imagePositionRight: '5px'
  },
  meet_up_beginner: {
    width: '58.55px',
    height: '59.31px',
    backgroundColor: theme.color.illustration.dandelion.default,
    cardPositionBottom: '97px',
    cardPositionRight: '0',
    imagePositionBottom: '-5px',
    imagePositionRight: '3px'
  },
  courses_intermediate: {
    width: '74.53px',
    height: '85.94px',
    backgroundColor: theme.color.illustration.violet.light,
    cardPositionBottom: '40px',
    cardPositionRight: '-115px',
    imagePositionBottom: '-4px',
    imagePositionRight: '0'
  },
  origins_intermediate: {
    width: '87px',
    height: '57px',
    backgroundColor: theme.color.illustration.emerald.default,
    cardPositionBottom: '0',
    cardPositionRight: '0',
    imagePositionBottom: '-10px',
    imagePositionRight: '-6px'
  },
  babbel_live_intermediate: {
    width: '87px',
    height: '57px',
    backgroundColor: theme.color.illustration.emerald.default,
    cardPositionBottom: '0',
    cardPositionRight: '0',
    imagePositionBottom: '-3px',
    imagePositionRight: '10px'
  },
  meet_up_intermediate: {
    width: '58.55px',
    height: '59.31px',
    backgroundColor: theme.color.illustration.dandelion.default,
    cardPositionBottom: '97px',
    cardPositionRight: '0',
    imagePositionBottom: '-5px',
    imagePositionRight: '3px'
  }
});
